// utils/trpc.ts
import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "../../../../src/api/trpc/rootRouter";
export const trpc = createTRPCReact<AppRouter>();
